export const VOICE_SUPPORT_HOURS = "09:00 AM to 07:00 PM (Monday to Saturday)";
export const CUSTOMER_SUPPORT_HOURS = "09:00 AM to 05:30 PM (Monday to Saturday)";
